// jQuery(function($) {
//   if ($('#js-tab').length) {
//     // 変数
//     var $target = $('#js-tab');
//     var $trigger = $target.find('.js-tabTrigger');
//     var headerHeight = 100;
    
//     // クリックイベント
//     $trigger.on('click', function () {
//       var $tabNav = $(this).closest('.js-tabNav');
//       var $tab = $tabNav.parents('#js-tab');
//       var $tabBody = $tab.find('.js-tabBody');
//       var $tabCont = $tabBody.find('.js-tabCont');
//       var _index = $tabNav.find('.js-tabTrigger').index(this);
//       var $currentTabBody = $tabCont.eq(_index);
      
//       // タブの切り替え
//       $tabNav.find('.js-tabTrigger').removeClass('is-current');
//       $(this).addClass('is-current');
//       $tabCont.removeClass('is-current');
//       $currentTabBody.addClass('is-current');
      
//       // スクロール
//       var scrollTo = $currentTabBody.offset().top - headerHeight;;
//       $('html, body').animate({
//         scrollTop: scrollTo
//       }, 500); // アニメーション時間を適宜調整
//     });
//   }
// });

jQuery(function($) {
  if ($('#js-tab').length) {
    // 変数
    var $target = $('#js-tab');
    var $trigger = $target.find('.js-tabTrigger');
    var headerHeight = 100;
    
    // 初期化時にURLのハッシュを取得し、対応するタブがあればアクティブにする
    var initialHash = window.location.hash;
    if (initialHash) {
      var $initialTab = $target.find('.js-tabCont').has(initialHash);
      if ($initialTab.length) {
        $trigger.removeClass('is-current');
        // $target.find('.js-tabTrigger[href="' + initialHash + '"]').addClass('is-current');
        $target.find('.js-tabCont').removeClass('is-current');
        $initialTab.addClass('is-current');
      }
    }
    
    // クリックイベント
    $trigger.on('click', function () {
      var $tabNav = $(this).closest('.js-tabNav');
      var $tab = $tabNav.parents('#js-tab');
      var $tabBody = $tab.find('.js-tabBody');
      var $tabCont = $tabBody.find('.js-tabCont');
      var _index = $tabNav.find('.js-tabTrigger').index(this);
      var $currentTabBody = $tabCont.eq(_index);
      
      // タブの切り替え
      $tabNav.find('.js-tabTrigger').removeClass('is-current');
      $(this).addClass('is-current');
      $tabCont.removeClass('is-current');
      $currentTabBody.addClass('is-current');
      
      // スクロール
      var scrollTo = $currentTabBody.offset().top - headerHeight;
      $('html, body').animate({
        scrollTop: scrollTo
      }, 500);
    });
  }
});

